export default function loadChatbotScript(options) {
  const script = document.createElement('script');
  script.src = options.src || 'http://59.110.83.53:3000/js/iframe.js';
  script.id = options.id || 'chatbot-iframe';
  script.defer = options.defer !== false;
  
  // 设置所有 data 属性
  if (options.data) {
    Object.keys(options.data).forEach(key => {
      script.dataset[key] = options.data[key];
    });
  }
  
  document.body.appendChild(script);
  
  return new Promise((resolve) => {
    script.onload = resolve;
  });
}

